<template>
  <!-- Modal -->
        <div class="modal fade" id="addCarrinho" tabindex="-1" data-keyboard="false"  role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" >{{produto.categoria?produto.categoria.nome:''}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="adicionar()">
                    <div class="modal-body">


                        <section class="title" v-if="produto.imagem_url">
                            <img :src="produto.imagem_url" :alt="produto.nome"  width="250" >

                        </section>

                        <div class="card my-3 px-3 py-2 d-flex flex-row header-card">
                            <div style="max-width: 300px;">
                                <h3>{{produto.nome}}</h3>
                                <p>{{produto.descricao}}</p>
                            </div>
                            <div class="ml-auto">
                                <div v-if="!isEmpty" class="d-flex flex-column" style="width:110px">
                                    <span v-if="produto.promocao" class="badge badge-pill badge-danger align-self-center mb-2">Em Promoção</span>
                                    <del v-if="produto.promocao" class="align-self-center mb-2">R$ {{formatarMoeda(produto.valor)}}</del>
                                    <h4 v-if="produto.promocao" class="preco align-self-center mb-2">R$ {{formatarMoeda(produto.promocao.valor)}}</h4>
                                    <h4 v-else class="preco align-self-center mb-2">R$ {{formatarMoeda(produto.valor)}}</h4>
                                </div>
                            </div>
                        </div>

                        <!-- PRODUTO POR ETAPAS -->

                        <template v-if="produto.tipo == 2">

                            <div v-for="(etapa, key) in mostrarEtapas" :key="key" >

                                <div v-if="key == etapaAtualKey" class="card my-3 p-3 d-flex flex-colunm">

                                    <div class="mb-2">
                                        <h5>{{etapa.nome}}</h5>
                                        <p v-if="etapa.multipla_escolha">A quantidade máxima de itens permitida para esta etapa e de: {{ etapa.qmaxima }} {{ etapa.qmaxima==1?" item":" itens" }}</p>
                                    </div>

                                    <div v-for="(item, itemKey) in etapa.itens" :key="itemKey" class="my-1 etapaItem">

                                        <div
                                            class="p-2 border border-success rounded d-flex flex-row justify-content-between"
                                            :class="[verificarItemSelecionado(item.pivot.id)?'active':'', etapa.multipla_escolha?'':'cursor']"
                                            @click="etapa.multipla_escolha?'':selecionarItem(item, etapa.obrigatorio)"
                                        >
                                            <div class="">
                                                <img :src="item.imagem" class="mr-2 float-left" height="60" alt="">
                                                {{item.nome}} <br>
                                                {{item.descricao&&item.descricao!="null"?item.descricao:''}}
                                            </div>

                                            <div>
                                                <div class="mb-1 text-center">
                                                    +R$ {{item.pivot.valor}}
                                                </div>
                                                <div v-if="etapa.multipla_escolha" class="text-right" style="min-width:76px">
                                                    <button type="button" class="btn b-btn opcionalBtn" v-on:click="retirarItem(item, key)" > - </button>
                                                    <div class="opcionalQt"> {{qtItem(item.pivot.id)}} </div>
                                                    <button type="button" class="btn b-btn opcionalBtn" v-on:click="adicionarItem(item, key, etapa.qmaxima)" > + </button>
                                                </div>
                                            </div>

                                        </div>



                                    </div>

                                </div>

                            </div>

                            <!-- Finalizar -->
                            <div v-if="confirmarEtapa">

                                <div class="card my-3 p-3">
                                    <div class="mb-3 text-center">
                                        <h3>Confirme suas escolhas</h3>
                                    </div>

                                    <div v-for="(etapa, key) in mostrarEtapas" :key="key">
                                        <div class="row titulo-categoria mb-3">
                                            <h4>{{etapa.nome}}</h4>

                                        </div>
                                        <div>

                                            <div v-for="item in formAddCarrinho.etapas.filter(item => item.pivot.mp_etapas_id == etapa.id)" :key="item" class="d-flex flex-row">

                                                <div>
                                                    <p>{{item.nome}}</p>
                                                </div>

                                                <div class="ml-auto">
                                                    <div style="width:110px; text-align: center ">
                                                        <span >+ R$ {{item.pivot.valor}}</span>

                                                    </div>
                                                </div>

                                            </div>
                                            <hr>
                                            <button type="button" class="btn btn-sm b-btn mb-3" @click="etapaAtualKey=key">alterar</button>
                                        </div>

                                    </div>


                                </div>

                                <!-- Adicionais -->

                                <div v-if="mostrarAdicionais.length > 0" class="card my-3 p-3 d-flex flex-colunm">
                                    <div style="max-width: 300px;" class="mb-3">
                                        <h5>Cobrança extra</h5>
                                    </div>
                                    <div v-for="item in mostrarAdicionais" :key="item.id" class="d-flex flex-row">

                                        <div>
                                            <p>{{item.nome}}</p>
                                        </div>

                                        <div class="ml-auto">
                                            <div style="width:110px; text-align: center ">
                                                <span >+ R$ {{item.valor}}</span>

                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <!-- OBS -->

                                <div class="card my-3 p-3 d-flex flex-colunm">
                                    <div style="max-width: 300px;" class="mb-3">
                                        <h5>Alguma Observação?</h5>
                                    </div>
                                    <div>
                                        <textarea v-model="formAddCarrinho.obs" placeholder="Ex: Sem azeitona"></textarea>
                                    </div>
                                </div>


                            </div>

                            <div class="d-flex flex-row">

                                <div class="ml-auto">
                                    <div class="mb-2">
                                        Valor Total:
                                    </div>
                                    <div>
                                        <h3>R$ {{formatarMoeda(vtotal.toFixed(2))}}</h3>
                                    </div>

                                </div>

                            </div>

                        </template>

                         <!-- / PRODUTO POR ETAPAS -->

                        <template v-else>

                            <!-- Opcionais -->

                            <div v-if="mostrarOpcionais.length > 0" class="card my-3 p-3 d-flex flex-colunm">
                                <div style="max-width: 300px;" class="mb-3">
                                    <h5>Adicionais</h5>
                                    <span>(Quantidade Máxima de itens: {{produto.grupoopcional.qmaxima}})</span>
                                </div>
                                <div v-for="item in mostrarOpcionais" :key="item.id" class="d-flex flex-row my-1">

                                    <div>

                                        <div v-if="produto.grupoopcional.multipla_escolha==1" >
                                            <button type="button" class="btn b-btn opcionalBtn" v-on:click="delOpcionais(item)" > - </button>
                                            <div class="opcionalQt"> {{qtOpcionais(item.id)}}  </div>
                                            <button type="button" class="btn b-btn opcionalBtn" v-on:click="addOpcionais(item)" > + </button>
                                            <span class="ml-1 opcionalNome">{{item.nome}}</span>
                                        </div>
                                        <template v-else>
                                            <input type="radio" :id="item.id" :value="item" v-model="formAddCarrinho.opcionais" >
                                            <label :for="item.id">{{item.nome}}</label>
                                        </template>
                                        <!-- <input v-if="produto.grupoopcional.multipla_escolha==1" type="checkbox" :id="item.id" :value="item" v-model="formAddCarrinho.opcionais" > -->

                                    </div>

                                    <div class="ml-auto">
                                        <div style="width:110px; text-align: center ">
                                            <span class="opcionalValor" >+ R$ {{item.valor}}</span>

                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- Adicionais -->

                            <div v-if="mostrarAdicionais.length > 0" class="card my-3 p-3 d-flex flex-colunm">
                                <div style="max-width: 300px;" class="mb-3">
                                    <h5>Cobrança extra</h5>
                                </div>
                                <div v-for="item in mostrarAdicionais" :key="item.id" class="d-flex flex-row">

                                    <div>
                                        <p>{{item.nome}}</p>
                                    </div>

                                    <div class="ml-auto">
                                        <div style="width:110px; text-align: center ">
                                            <span >+ R$ {{item.valor}}</span>

                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- OBS -->

                            <div class="card my-3 p-3 d-flex flex-colunm">
                                <div style="max-width: 300px;" class="mb-3">
                                    <h5>Alguma Observação?</h5>
                                </div>
                                <div>
                                    <textarea v-model="formAddCarrinho.obs" placeholder="Ex: Sem azeitona"></textarea>
                                </div>
                            </div>


                            <div class="d-flex flex-row">
                                <div>
                                    <div class="mb-2">
                                        Quantidade:
                                    </div>
                                    <div v-if="formAddCarrinho.produto.unidade_de_medida=='unidade'">
                                        <button type="button" class="btn b-btn" v-on:click="formAddCarrinho.quantidade>1?formAddCarrinho.quantidade -= 1:''"> - </button>
                                        <div class="qt"> {{formAddCarrinho.quantidade}}  </div>
                                        <button type="button" class="btn b-btn" v-on:click="formAddCarrinho.quantidade += 1" > + </button>
                                    </div>
                                    <div v-if="formAddCarrinho.produto.unidade_de_medida=='kg'">

                                        <money
                                                v-model="formAddCarrinho.quantidade"
                                                type="text"
                                                class="form-control form-control-md"
                                                prefix=''
                                                suffix=' Kg'
                                                precision=3
                                            >
                                        </money>

                                        <!-- <input type="text" name="qt" id="qt" v-model="formAddCarrinho.quantidade" > -->
                                    </div>
                                </div>

                                <div class="ml-auto">
                                    <div class="mb-2">
                                        Valor Total:
                                    </div>
                                    <div>
                                        <h3>R$ {{formatarMoeda(vtotal.toFixed(2))}}</h3>
                                    </div>

                                </div>

                            </div>

                        </template>







                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-auto" data-dismiss="modal">Fechar</button>
                        <template v-if="produto.etapas.length>0">
                            <button v-if="mostrarEtapas[etapaAtualKey-1]" type="button" @click="etapaAtualKey--" class="btn b-btn"> <i class="fas fa-angle-double-left"></i> {{mostrarEtapas[etapaAtualKey-1].nome}}</button>
                            <button v-if="confirmarEtapa" type="button" @click="etapaAtualKey=mostrarEtapas.length-1" class="btn b-btn"> <i class="fas fa-angle-double-left"></i> {{mostrarEtapas[mostrarEtapas.length-1].nome}}</button>
                            <button v-if="mostrarEtapas[etapaAtualKey+1]&&etapaAtualKey!=null" type="button" @click="verificarSelecaoObrigatoria(mostrarEtapas[etapaAtualKey].id, etapaAtualKey)?etapaAtualKey++:''" class="btn b-btn">{{mostrarEtapas[etapaAtualKey+1].nome}} <i class="fas fa-angle-double-right"></i> </button>
                            <button v-else-if="confirmarEtapa==false" type="button" class="btn b-btn" @click="etapasTelaFFinal()">Proximo</button>
                            <button v-if="confirmarEtapa" type="submit" class="btn b-btn" @click="etapasTelaFFinal()">Adicionar ao Carrinho</button>

                        </template>
                        <template v-else>
                            <button type="submit" class="btn b-btn">Adicionar</button>
                        </template>
                    </div>
                  </form>
                </div>
            </div>
        </div>
</template>

<script>

import api from "../service/api";
import Cookie from "js-cookie";
import { vueTagsInput } from "@johmun/vue-tags-input";
export default {
    data () {
        return {
            mostrarOpcionais:[],
            mostrarAdicionais:[],
            mostrarEtapas:[],
            etapaAtualKey: 0,
            confirmarEtapa: false,
            contadorEtapas: [],
            formAddCarrinho: new Form({
                id : '',
                tipo: 1,
                produto:{},
                opcionais: [],
                adicionais: [],
                etapas: [],
                quantidade: 1,
                obs:''
            }),
        }
    },

    watch: {
        produto: function (produto) {
            this.resetarProduto(produto)
        },

        produtoDoCarrinho: function (item) {

            this.teste(item.produto);

            // let obj1 = JSON.parse(JSON.stringify(item.produto));
            
            // this.$store.dispatch('atualizarProdutoAtivo', obj1).then();
        },

        aleatorio: function () {
            this.teste(this.produtoDoCarrinho.produto);
        },


        etapaAtualKey: function (key) {

            if (key != null) {
                this.confirmarEtapa = false
            }


        },

    },

    methods: {

        async teste(prod){

            let obj1 = JSON.parse(JSON.stringify(prod));

            await this.$store.dispatch('atualizarProdutoAtivo', obj1).then();

        },

        formatarMoeda(valor){
              return valor.replace(".",",")
        },

        adicionar() {
            if ( this.produto.grupoopcional && this.produto.grupoopcional.multipla_escolha==0 && this.formAddCarrinho.opcionais.length == 0) {

                Swal.fire({
                    title: 'É obrigatório a escolha de um adicional',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok!'
                })

            }else{

                
                if (this.produtoDoCarrinho != null) {

                    let obj = { 
                        index: this.$store.state.produtoAtivo.produtoSelecionadoIndex ,
                        produto: this.formAddCarrinho
                    };

                    let item = JSON.parse(JSON.stringify(obj));

                    this.$store.dispatch('editarProduto', item).then();
                    
                }else{
                    let obj1 = JSON.parse(JSON.stringify(this.formAddCarrinho));
                    this.$store.dispatch('adicionarProduto', obj1).then();
                    
                }

                this.$store.dispatch('valorAleatorio').then();

                // let obj1 = JSON.parse(JSON.stringify(this.formAddCarrinho));
                // this.$store.dispatch('adicionarProduto', obj1).then();

                $('#addCarrinho').modal('hide');

                Toast.fire({
                    icon: 'success',
                    title: "Item Adicionado no Carrinho"
                });

                fbq('track', 'AddToCart', {

                    content_name: this.formAddCarrinho.produto.nome,
                    content_ids: [this.formAddCarrinho.produto.pdv],
                    content_type: 'produto',
                    quantity: this.formAddCarrinho.quantidade,
                    value: this.vtotal,
                    currency: 'BRL'
                });

                this.resetarProduto(this.produto);
            }


        },

        limparForm() {
            this.formAddCarrinho.reset();
            this.mostrarOpcionais = [];
            this.formAddCarrinho.errors.errors = {};
        },

        resetarProduto(produto)  {
            this.limparForm()
            this.formAddCarrinho.produto = produto;
            this.mostrarEtapas = produto.etapas;
            this.etapaAtualKey = 0;
            produto.etapas.forEach((etapa, key) => {
                this.contadorEtapas[key] = 0;
            });
            this.mostrarAdicionais = produto.adicionais;
            this.formAddCarrinho.adicionais = produto.adicionais;
            if (produto.grupoopcional && produto.grupoopcional.opcionais_disponiveis.length > 0) {
                this.mostrarOpcionais = produto.grupoopcional.opcionais_disponiveis;
            };

            if (this.produtoDoCarrinho != null) {

                let obj1 = JSON.parse(JSON.stringify(this.produtoDoCarrinho));

                console.log(this.produtoDoCarrinho);

                this.formAddCarrinho.fill(obj1);
            }
        },

        addOpcionais(item){


            if (this.formAddCarrinho.opcionais.length < this.produto.grupoopcional.qmaxima ) {

                let quantidade =  this.formAddCarrinho.opcionais.filter(opcional => opcional.id==item.id);

                if (quantidade.length<item.pivot.maximo) {
                    this.formAddCarrinho.opcionais.push(item);
                }
            }


        },

        delOpcionais(item){

            // let obj1 = JSON.parse(JSON.stringify(item));


            // let nitem = this.formAddCarrinho.opcionais.indexOf(obj1);

            const index = this.formAddCarrinho.opcionais.findIndex(obj => obj.id === item.id);

            console.log(index);

            if(index>-1){
                this.formAddCarrinho.opcionais.splice(index, 1);
            }

        },

        qtOpcionais(id){

            let quantidade =  this.formAddCarrinho.opcionais.filter(opcional => opcional.id==id);

            return quantidade.length;
        },

        selecionarItem(item, obrigatorio){

            let quantidade =  this.formAddCarrinho.etapas.filter(etapa => etapa.pivot.mp_etapas_id == item.pivot.mp_etapas_id)
            if (quantidade.length>0) {
                let nitem = this.formAddCarrinho.etapas.indexOf(quantidade[0]);
                if(nitem>-1){
                    if (obrigatorio) {
                        
                        Vue.set(this.formAddCarrinho.etapas, nitem, item );

                    }else{

                        if (item == this.formAddCarrinho.etapas[nitem]) {

                            this.formAddCarrinho.etapas.splice(nitem, 1);

                        }else{
                            Vue.set(this.formAddCarrinho.etapas, nitem, item );
                        }

                    }
                }
            }else{
                this.formAddCarrinho.etapas.push(item)
            }
            // this.formAddCarrinho.etapas[key] = item;
            // Vue.set(this.formAddCarrinho.etapas, key, item );
        },

        verificarItemSelecionado(id){
            let quantidade =  this.formAddCarrinho.etapas.filter(etapa => etapa.pivot.id == id)
            if (quantidade.length>0) {
                return true
            }else{
                return false
            }
        },


        verificarSelecaoObrigatoria(etapaId, key){

            if (this.mostrarEtapas[key].obrigatorio==1) {
                let quantidade =  this.formAddCarrinho.etapas.filter(etapa => etapa.pivot.mp_etapas_id == etapaId)
                if (quantidade.length>0) {
                    return true
                }else{
                    Toast.fire({
                        icon: 'error',
                        title: 'Seleção Obrigatória'
                    });
                    return false
                }
            }else{
                return true
            }

        },

        etapasTelaFFinal(){
            this.etapaAtualKey = null;
            this.confirmarEtapa = true;
        },

        adicionarItem(item, key, qmaxima){

            if (this.contadorEtapas[key] < qmaxima ) {
                let quantidade =  this.formAddCarrinho.etapas.filter(etapa => etapa.pivot.id == item.pivot.id);

                if (quantidade.length<item.pivot.quantidade_maxima) {
                    this.formAddCarrinho.etapas.push(item);
                    this.contadorEtapas[key] += 1;
                }
            }


        },

        retirarItem(item, key){

            let nitem = this.formAddCarrinho.etapas.indexOf(item);
            if(nitem>-1){
                this.formAddCarrinho.etapas.splice(nitem, 1);
                this.contadorEtapas[key] -= 1;
            }
        },

        qtItem(id){
            let quantidade =  this.formAddCarrinho.etapas.filter(etapa => etapa.pivot.id == id);
            return quantidade.length;
        },





    },

    mounted () {
        this.resetarProduto(this.produto);
    },


    computed: {
        produto() {
            // if (this.produtoDoCarrinho != null) {
            //     this.$store.dispatch('atualizarProdutoAtivo', this.produtoDoCarrinho.produto).then();
            // }

            return this.$store.state.produtoAtivo.main;
        },

        produtoDoCarrinho() {

            return this.$store.state.produtosSelecionados.main[this.$store.state.produtoAtivo.produtoSelecionadoIndex];
        },

        aleatorio(){
            return this.$store.state.produtosSelecionados.valorAleatorio;
        },

        isEmpty: function() {
            return Object.keys(this.produto).length === 0 && this.produto.constructor === Object;
        },

        vtotal: function() {
            let valorProduto = 0;
            let valorOpcional = 0;
            let valorAdicional = 0;
            let valorEtapas = 0;
            let qt = 1;

            if (this.formAddCarrinho.produto.promocao) {
                valorProduto += parseFloat(this.formAddCarrinho.produto.promocao.valor);
            }else{
                valorProduto += parseFloat(this.formAddCarrinho.produto.valor);
            }

            if (this.produto.grupoopcional) {

                if (this.produto.grupoopcional.multipla_escolha==1) {
                    for (let index = 0; index < this.formAddCarrinho.opcionais.length; index++) {
                        valorOpcional += parseFloat(this.formAddCarrinho.opcionais[index].valor)
                    }
                }else{
                    if (this.formAddCarrinho.opcionais.valor) {
                        valorOpcional += parseFloat(this.formAddCarrinho.opcionais.valor)
                    }else{
                        valorOpcional += 0
                    }
                }
            }


            for (let index = 0; index < this.formAddCarrinho.adicionais.length; index++) {
                valorAdicional += parseFloat(this.formAddCarrinho.adicionais[index].valor)
            }

            for (let index = 0; index < this.formAddCarrinho.etapas.length; index++) {
                valorEtapas += parseFloat(this.formAddCarrinho.etapas[index].pivot.valor)
            }

            return this.formAddCarrinho.quantidade*(valorProduto+valorOpcional+valorAdicional+valorEtapas)
        }

    }

}
</script>

<style scoped>

.card {
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0.07));
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 0.8rem;
}

.card textarea{
    width: 100%;
    height: 100px;
    padding: 5px;
}

.title{
    text-align: center;
}

.title img {
    margin-left: 20px;
    padding: 4px;
    border: 1px solid #9c9c9c;
    border-radius: 2px;
    object-fit: cover;
    box-shadow: 2px 2px 4px 0px #a7a7a7;
}

.qt{
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.20);
    font-size: 1.2rem;
    width: 35px;
    height: 30px;
    text-align: center;
}

.opcionalNome{
    font-size: 1.1rem;
}

.opcionalValor{
    font-size: 0.8rem;
}

.opcionalQt{
    display: inline-block;
    /* border: 1px solid rgba(0, 0, 0, 0.20); */
    font-size: 1.1rem;
    min-width: 15px;
    height: 25px;
    text-align: center;
}

.opcionalBtn{
    padding: 5px 8px;
}

.etapaItem{
    background-image: linear-gradient(to bottom, rgba(98,211,117,0),rgba(98,211,117,0), rgba(98,211,117,0.07));

}
.etapaItem .cursor{
    cursor: pointer;
}

.etapaItem img{
    border: 2px solid #fff;
    cursor: zoom-in;
    max-width: 60px;
    object-fit: cover;
}

.etapaItem:hover{
    /* background-color: rgb(215, 241, 221); */
    background-image: linear-gradient(to bottom, rgba(215,241,221,0.95),rgba(215,241,221,0.9), rgba(215,241,221,0.5));
    box-shadow: 2px 2px 6px 0px #a7a7a7;
    border-color: green;
}

.etapaItem .active{
    /* background-color: rgb(98, 211, 117); */
    background-image: linear-gradient(to bottom, rgba(98,211,117,0.95),rgba(98,211,117,0.9), rgba(98,211,117,0.5));
    color: #fff
}

.titulo-categoria{
    border-bottom: 5px solid var(--btnbg3);
}

.titulo-categoria h4 {
    padding: 8px 20px;
    color: var(--btntxt3);
    background:  var(--btnbg3);
    margin-bottom: -1px;
    border-top-right-radius: 10px;
    font-family: 'Lobster', cursive;
    text-shadow: -1px 1px 4px black;
}

.header-card{
    color: var(--btntxt3);
    background-color: var(--btnbg3);
    text-shadow: -1px 1px 4px black;
}

.header-card h3{
    color: var(--btntxt3);
    font-family: 'Lobster', cursive;
    text-transform: lowercase !important;
}

.header-card h3:first-letter{
    text-transform: capitalize !important;
}


</style>
